import React, { HtmlHTMLAttributes } from 'react';
import { IconWithNameProps } from 'components/CustomIcon';
import * as Styled from './MBSelect.styles';
import { MBSelectProps } from './MBSelect.types';

export const ArrowIcon: React.FC<
  HtmlHTMLAttributes<HTMLSpanElement> & IconWithNameProps
> = (props) => {
  return <Styled.Icon {...props} name="down" dense size={0.8} />;
};

const MBSelect: React.FC<MBSelectProps> = (props) => {
  return (
    <Styled.Wrapper
      selectSize={props.selectSize}
      unstyled={props.unstyled}
      itemsMinWidth={props.itemsMinWidth}
    >
      {}
      {/* @ts-ignore */}
      <Styled.SelectBox
        {...props}
        IconComponent={ArrowIcon}
        MenuProps={{
          disablePortal: true,
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
        }}
      />
      {props.helperText && typeof props.helperText === 'string' ? (
        <Styled.HelperText>{props.helperText}</Styled.HelperText>
      ) : (
        props.helperText
      )}
    </Styled.Wrapper>
  );
};

export default MBSelect;
